export const equipmentApi = {
    list: {
        method: 'post',
        api: 'admin/equipment/list'
    },
    get: {
      method: 'post',
      api: 'admin/equipment/get'
    },
    save: {
      method: 'post',
      api: 'admin/equipment/save'
    },
    del: {
      method: 'post',
      api: 'admin/equipment/del'
    },
    get_cates_list: {
      method: 'post',
      api: 'admin/equipment/get_cates_list'
  },
  del_cates: {
      method: 'post',
      api: 'admin/equipment/del_cates'
  },
  save_cates: {
      method: 'post',
      api: 'admin/equipment/save_cates'
  },
  }